var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 12.4286C11.2133 12.4286 12.4286 11.2133 12.4286 9.71429C12.4286 8.21523 11.2133 7 9.71429 7C8.21523 7 7 8.21523 7 9.71429C7 11.2133 8.21523 12.4286 9.71429 12.4286Z",
    fill: "#DB1C29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.4286C17.9991 12.4286 19.2143 11.2133 19.2143 9.71429C19.2143 8.21523 17.9991 7 16.5 7C15.0009 7 13.7857 8.21523 13.7857 9.71429C13.7857 11.2133 15.0009 12.4286 16.5 12.4286Z",
    fill: "#DB1C29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 12.4286C24.7848 12.4286 26 11.2133 26 9.71429C26 8.21523 24.7848 7 23.2857 7C21.7867 7 20.5714 8.21523 20.5714 9.71429C20.5714 11.2133 21.7867 12.4286 23.2857 12.4286Z",
    fill: "#DB1C29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 19.2143C11.2133 19.2143 12.4286 17.9991 12.4286 16.5C12.4286 15.0009 11.2133 13.7857 9.71429 13.7857C8.21523 13.7857 7 15.0009 7 16.5C7 17.9991 8.21523 19.2143 9.71429 19.2143Z",
    fill: "#DB1C29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.2143C17.9991 19.2143 19.2143 17.9991 19.2143 16.5C19.2143 15.0009 17.9991 13.7857 16.5 13.7857C15.0009 13.7857 13.7857 15.0009 13.7857 16.5C13.7857 17.9991 15.0009 19.2143 16.5 19.2143Z",
    fill: "#DB1C29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 19.2143C24.7848 19.2143 26 17.9991 26 16.5C26 15.0009 24.7848 13.7857 23.2857 13.7857C21.7867 13.7857 20.5714 15.0009 20.5714 16.5C20.5714 17.9991 21.7867 19.2143 23.2857 19.2143Z",
    fill: "#DB1C29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71429 26C11.2133 26 12.4286 24.7848 12.4286 23.2857C12.4286 21.7867 11.2133 20.5714 9.71429 20.5714C8.21523 20.5714 7 21.7867 7 23.2857C7 24.7848 8.21523 26 9.71429 26Z",
    fill: "#DB1C29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26C17.9991 26 19.2143 24.7848 19.2143 23.2857C19.2143 21.7867 17.9991 20.5714 16.5 20.5714C15.0009 20.5714 13.7857 21.7867 13.7857 23.2857C13.7857 24.7848 15.0009 26 16.5 26Z",
    fill: "#DB1C29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 26C24.7848 26 26 24.7848 26 23.2857C26 21.7867 24.7848 20.5714 23.2857 20.5714C21.7867 20.5714 20.5714 21.7867 20.5714 23.2857C20.5714 24.7848 21.7867 26 23.2857 26Z",
    fill: "#DB1C29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMis);
export default __webpack_public_path__ + "static/media/MIS.ca576f160e9805ca5bd7e0b32f355734.svg";
export { ForwardRef as ReactComponent };